import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { RADIUS } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import { LBButton, LBXIcon } from '@linearb/buzz';

const MODAL_SIZES = {
  fullscreen: { width: '98%', height: '96%' },
  big: { width: '100rem', height: '100rem' },
  backgrounded: { width: '84rem', height: '57rem' },
  login: { width: '40rem', height: '60rem' },
  normal: { width: '80rem', height: '50rem' },
  medium: { width: '60rem', height: '40rem' },
  small: { width: '40rem', height: '40rem' },
  portrait: { width: '47rem', height: '54rem' }
};

const Wrapper = styled.div`
  ${({ size, width }) =>
    `width: ${width || MODAL_SIZES[size || 'normal']['width']}; min-width: ${
      width || MODAL_SIZES[size || 'normal']['width']
    }`};
  ${({ size, height }) =>
    `height: ${
      height || MODAL_SIZES[size || 'normal']['height']
    }; min-height: ${height || MODAL_SIZES[size || 'normal']['height']}`};
  background-color: ${getColor('white')};
  border-radius: ${RADIUS.medium};
  position: relative;
  outline: none;
`;

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:focus': {
      outline: 'none'
    }
  }
});

const WrappedModal = ({
  isOpen,
  onClose,
  size,
  toggleModal,
  content = () => null,
  ContentWrapper = null,
  classes,
  showCloseButton = true,
  modalParams,
  height,
  width,
  wrapperProps = {},
  ...params
}) => {
  const escFunction = event => {
    if (event.key === 'Escape' && showCloseButton) {
      closeModal();
    }
  };

  const closeModal = () => {
    if (!isOpen) return;
    onClose ? onClose() : toggleModal();
  };

  const Content = content({
    ...params,
    closeModal
  });
  return (
    <Modal
      id='wrappedModal'
      open={isOpen}
      onClose={onClose}
      className={classes.root}
      onKeyDown={escFunction}
      {...modalParams}
    >
      <Wrapper size={size} height={height} width={width} {...wrapperProps}>
        {showCloseButton && (
          <div className='absolute right-0 top-0 pr-4 pt-4'>
            <LBButton
              id='closeModal'
              onClick={closeModal}
              size='icon'
              variant='ghost'
            >
              <LBXIcon />
            </LBButton>
          </div>
        )}
        {ContentWrapper ? (
          <ContentWrapper>{Content}</ContentWrapper>
        ) : (
          <>{Content}</>
        )}
      </Wrapper>
    </Modal>
  );
};

export default withStyles(styles)(WrappedModal);
